import {css, unsafeCSS} from "lit";
import {sbkCoreBreakpointLg} from "@/tokens/variables";

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
    :host {
        --headline-link__border--focus: var(--_headline-link__border--focus, var(--sbkHeadlineLinkBorderOnLightFocus));

        --headline-link__color: var(--_headline-link__color, var(--sbkHeadlineLinkFgColorOnLightEnabled));
        --headline-link__color--hover: var(--_headline-link__color--hover, var(--sbkHeadlineLinkFgColorOnLightHover));
        --headline-link__color--active: var(--_headline-link__color--active, var(--sbkHeadlineLinkFgColorOnLightActive));
        --headline-link__color--disabled: var(--_headline-link__color--disabled, var(--sbkHeadlineLinkFgColorOnLightDisabled));
        --headline-link__color--visited: var(--_headline-link__color--visited, var(--sbkHeadlineLinkFgColorOnLightVisited));
        width: 100%;
    }
    
    * {
        box-sizing: border-box;
    }


    a, span {
        text-decoration: none;
        hyphens: auto;
        color: var(--headline-link__color);
        outline: 2px solid transparent;
        outline-offset: var(--sbkLinkBorderGapFocus);
        border-radius: var(--sbkLinkBorderRadiusFocus);
        border: none;
        cursor: pointer;
        display: inline-block;

        @media (hover: hover) and (pointer: fine) {
            &:hover {
                color: var(--headline-link__color--hover);
                text-decoration: underline;
            }
        }

        &:active {
            color: var(--headline-link__color--active);
            text-decoration: underline;
        }

        &:visited {
            color: var(--headline-link__color--visited);
            text-decoration: underline;
        }

        &:disabled {
            color: var(--headline-link__color--disabled);
            pointer-events: none;
        }

        &:focus-visible {
            outline: var(--headline-link__border--focus);
        }
        
        &:after {
            content: "";
            display: inline-block;
            width: var(--sbkHeadlineLinkSizingSmallScrXs);
            height: var(--sbkHeadlineLinkSizingSmallScrXs);
            background-color: currentColor;
            mask-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.99938 19.2001C8.68938 19.2001 8.38937 19.0801 8.14937 18.8501C7.67937 18.3801 7.67937 17.6201 8.14937 17.1501L13.3094 11.9801L8.17938 6.85011C7.70938 6.38011 7.70938 5.62011 8.17938 5.15011C8.64938 4.68011 9.40938 4.68011 9.87938 5.15011L16.7094 11.9801L9.84938 18.8501C9.61938 19.0901 9.30938 19.2001 8.99938 19.2001Z'/%3E%3C/svg%3E%0A");
            mask-repeat: no-repeat;
            mask-size: contain;
            mask-position: center;
            vertical-align: sub;
        }
    }

    .icon {
        box-sizing: border-box;
        vertical-align: sub;
        fill: currentColor;
    }

    .xxl {
        font: var(--sbkHeadlineLinkTypographySmallScrBold2xl);
        padding-right: var(--sbkHeadlineLinkSizingSmallScr2xl);
        &:after {
            height: var(--sbkHeadlineLinkSizingSmallScr2xl);
            width: var(--sbkHeadlineLinkSizingSmallScr2xl);
            margin-right: calc(-1 * var(--sbkHeadlineLinkSizingSmallScr2xl));
        }

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBold2xl);
            padding-right: var(--sbkHeadlineLinkTypographyLargeScrBold2xl);
            &:after {
                height: var(--sbkHeadlineLinkSizingLargeScr2xl);
                width: var(--sbkHeadlineLinkSizingLargeScr2xl);
                margin-right: calc(-1 * var(--sbkHeadlineLinkSizingLargeScr2xl));
            }
        }
    }

    .xxl.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlined2xl);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlined2xl);
        }
    }

    .xl {
        font: var(--sbkHeadlineLinkTypographySmallScrBoldXl);
        padding-right: var(--sbkHeadlineLinkSizingSmallScrXl);
        &:after {
            height: var(--sbkHeadlineLinkSizingSmallScrXl);
            width: var(--sbkHeadlineLinkSizingSmallScrXl);
            margin-right: calc(-1 * var(--sbkHeadlineLinkSizingSmallScrXl));
        }
        
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldXl);
            padding-right: var(--sbkHeadlineLinkSizingLargeScrXl);
            &:after {
                height: var(--sbkHeadlineLinkSizingLargeScrXl);
                width: var(--sbkHeadlineLinkSizingLargeScrXl);
                margin-right: calc(-1 * var(--sbkHeadlineLinkSizingLargeScrXl));
            }
        }
    }

    .xs.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlinedXl);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlinedXl);
        }
    }

    .lg {
        font: var(--sbkHeadlineLinkTypographySmallScrBoldLg);
        padding-right: var(--sbkHeadlineLinkSizingSmallScrLg);
        &:after {
            height: var(--sbkHeadlineLinkSizingSmallScrLg);
            width: var(--sbkHeadlineLinkSizingSmallScrLg);
            margin-right: calc(-1 * var(--sbkHeadlineLinkSizingSmallScrLg));
        }
        
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldLg);
            padding-right: var(--sbkHeadlineLinkSizingLargeScrLg);
            &:after {
                height: var(--sbkHeadlineLinkSizingLargeScrLg);
                width: var(--sbkHeadlineLinkSizingLargeScrLg);
                margin-right: calc(-1 * var(--sbkHeadlineLinkSizingLargeScrLg));
            }
        }
    }

    .lg.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlinedLg);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlinedLg);
        }
    }

    .md {
        font: var(--sbkHeadlineLinkTypographySmallScrBoldMd);
        padding-right: var(--sbkHeadlineLinkSizingSmallScrMd);
        &:after {
            height: var(--sbkHeadlineLinkSizingSmallScrMd);
            width: var(--sbkHeadlineLinkSizingSmallScrMd);
            margin-right: calc(-1 * var(--sbkHeadlineLinkSizingSmallScrMd));
        }

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldMd);
            padding-right: var(--sbkHeadlineLinkSizingLargeScrMd);
            &:after {
                height: var(--sbkHeadlineLinkSizingLargeScrMd);
                width: var(--sbkHeadlineLinkSizingLargeScrMd);
                margin-right: calc(-1 * var(--sbkHeadlineLinkSizingLargeScrMd));
            }
        }
    }

    .md.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlinedMd);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlinedMd);
        }
    }

    .sm {
        font: var(--sbkHeadlineLinkTypographySmallScrBoldSm);
        padding-right: var(--sbkHeadlineLinkSizingSmallScrSm);

        &:after {
            height: var(--sbkHeadlineLinkSizingSmallScrSm);
            width: var(--sbkHeadlineLinkSizingSmallScrSm);
            margin-right: calc(-1 * var(--sbkHeadlineLinkSizingSmallScrSm));
        }
        
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldSm);
            padding-right: var(--sbkHeadlineLinkSizingLargeScrSm);
            &:after {
                height: var(--sbkHeadlineLinkSizingLargeScrSm);
                width: var(--sbkHeadlineLinkSizingLargeScrSm);
                margin-right: calc(-1 * var(--sbkHeadlineLinkSizingLargeScrSm));
            }
        }
    }

    .sm.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlinedSm);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlinedSm);
        }
    }

    .xs {
        font: var(--sbkHeadlineLinkTypographySmallScrBoldXs);
        padding-right: var(--sbkHeadlineLinkSizingSmallScrXs);

        &:after {
            height: var(--sbkHeadlineLinkSizingSmallScrXs);
            width: var(--sbkHeadlineLinkSizingSmallScrXs);
            margin-right: calc(-1 * var(--sbkHeadlineLinkSizingSmallScrXs));
        }

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldXs);
            padding-right: var(--sbkHeadlineLinkSizingLargeScrXs);
            &:after {
                height: var(--sbkHeadlineLinkSizingLargeScrXs);
                width: var(--sbkHeadlineLinkSizingLargeScrXs);
                margin-right: calc(-1 * var(--sbkHeadlineLinkSizingLargeScrXs));
            }
        }
    }

    .xs.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlinedXs);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlinedXs);
        }
    }
`;

